{
  "name": "idhub",
  "version": "2.0.0",
  "scripts": {
    "ng": "ng",
    "icons:sprite": "node tools/build-sprite.mjs",
    "prestart": "yarn icons:sprite",
    "start": "ng serve --host 0.0.0.0 --port 4444",
    "prebuild": "yarn icons:sprite",
    "build": "ng build",
    "prebuild:production": "yarn icons:sprite",
    "build:production": "ng build --configuration production",
    "icons:optimize": "svgo -f src/assets/icons --config=.svgo.config.cjs",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "format": "prettier --write --config ./.prettierrc src/**/*{.ts,.scss,.html}",
    "format:check": "prettier --check .",
    "lint:scss": "stylelint 'src/**/**.scss'",
    "lint:ts": "tsc --noEmit && eslint 'src/**/**.ts'"
  },
  "husky": {
    "hooks": {
      "pre-commit": "npm --no-git-tag-version version patch && git add package.json"
    }
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.0",
    "@angular/cdk": "21",
    "@angular/common": "21.2.0",
    "@angular/compiler": "21.2.0",
    "@angular/core": "21.2.0",
    "@angular/forms": "21.2.0",
    "@angular/localize": "21.2.0",
    "@angular/platform-browser": "21.2.0",
    "@angular/platform-browser-dynamic": "21.2.0",
    "@angular/pwa": "^21.1.4",
    "@angular/router": "21.2.0",
    "@angular/service-worker": "21.2.0",
    "@assecods/design-system": "^1.1.23",
    "@assecods/ng-design-system": "^20.1.20",
    "@ng-bootstrap/ng-bootstrap": "19.0.0",
    "@ng-select/ng-select": "^21.4.0",
    "@ngx-translate/core": "^16.0.3",
    "@ngx-translate/http-loader": "^16.0.0",
    "@popperjs/core": "^2.11.8",
    "@types/lodash-es": "^4.17.9",
    "@types/qrcode": "^1.5.2",
    "bootstrap": "^5.3.0",
    "date-fns": "4",
    "lodash-es": "4.17.23",
    "ng2-file-upload": "^9.0.0",
    "ngx-device-detector": "^11.0.0",
    "ngx-mask": "15.1.5",
    "rxjs": "^7.8",
    "simplebar": "^6.3.3",
    "simplebar-angular": "^3.3.2",
    "simplebar-core": "^1.3.2",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21",
    "@angular-devkit/core": "21",
    "@angular-devkit/schematics": "21",
    "@angular-eslint/builder": "20.2.0",
    "@angular-eslint/eslint-plugin": "20.2.0",
    "@angular-eslint/eslint-plugin-template": "20.2.0",
    "@angular-eslint/schematics": "20.2.0",
    "@angular-eslint/template-parser": "20.2.0",
    "@angular/cli": "^21.2.0",
    "@angular/compiler-cli": "21.2.0",
    "@types/jasmine": "~3.6.0",
    "@types/jest": "^29.5.12",
    "@types/node": "^20.10.5",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "codelyzer": "^6.0.0",
    "eslint": "9.26.0",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-airbnb-angular": "^1.0.0",
    "eslint-config-airbnb-typescript": "^17.1.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-angular": "^4.1.0",
    "eslint-plugin-import": "^2.22.1",
    "eslint-plugin-jsx-a11y": "^6.4.1",
    "eslint-plugin-prettier": "^5.1.2",
    "husky": "^9.0.11",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "jest": "^29.7.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "prettier": "^3.1.1",
    "protractor": "~7.0.0",
    "stylelint": "^13.13.1",
    "stylelint-config-sass-guidelines": "^8.0.0",
    "svgo": "^4.0.0",
    "svgstore": "^3.0.1",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "tslint-config-prettier": "^1.18.0",
    "typescript": "~5.9.3"
  },
  "engines": {
    "node": ">=20.19.0",
    "yarn": ">=4.5",
    "npm": "Please use yarn instead of NPM to install dependencies"
  },
  "packageManager": "yarn@4.5.0"
}
